import { render, staticRenderFns } from "./ApplyReject.vue?vue&type=template&id=c513f928&scoped=true&"
import script from "./ApplyReject.vue?vue&type=script&lang=js&"
export * from "./ApplyReject.vue?vue&type=script&lang=js&"
import style0 from "./ApplyReject.vue?vue&type=style&index=0&id=c513f928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c513f928",
  null
  
)

export default component.exports